import React from 'react';
import './css/CoverSection.css';
import coverImg from '../../../assets/images/logo/14.png';

export default function CoverSection({ data, youtubeVideoId }) {
  const coverImage = data?.imagem || coverImg;
  const coverText = data?.texto || 'Seja bem-vindo ao site da ADCN';
  // Prioriza youtubeVideoId, depois data.videoId, e só usa fallback se ambos forem vazios/undefined
  const videoId = youtubeVideoId || data?.videoId || 'QLEyzNunHKo';
  
  console.log('[CoverSection] Props recebidas:', { youtubeVideoId, 'data?.videoId': data?.videoId, 'data?.imagem': data?.imagem });
  console.log('[CoverSection] videoId final que será usado:', videoId);
  console.log('[CoverSection] coverImage final:', coverImage);

  return (
    <section className="cover-section-container">
      <div 
        className="cover-image"
        style={{ backgroundImage: `url("${coverImage}")` }}
      />
      <div className="cover-content">
        <h2>{coverText}</h2>
        <div className="video-wrapper">
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?si=liWAtKS7PrTHG1vN`}
            title="Boas-vindas Pastor André"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}
